import { Box, Divider, Typography } from "@mui/material";

import { parseDisplayDate } from "./dateBadgeUtils";

interface DocumentDateBadgeProps {
  date?: string | null;
  time?: string | null;
  /** Cor de fundo do badge — padrão laranja da referência visual */
  accentColor?: string;
}

export function DocumentDateBadge({
  date,
  time,
  accentColor = "#D47F21",
}: DocumentDateBadgeProps) {
  const parts = parseDisplayDate(date, time);

  if (!parts) return null;

  return (
    <Box
      sx={{
        width: 58,
        flexShrink: 0,
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.25,
        py: 1.5,
        px: 0.5,
        bgcolor: accentColor,
        color: "#fff",
        borderRadius: "12px 0 0 12px",
      }}
    >
      <Typography
        sx={{
          fontSize: "0.62rem",
          fontWeight: 700,
          letterSpacing: 0.6,
          lineHeight: 1,
        }}
      >
        {parts.weekday}
      </Typography>

      <Typography
        sx={{
          fontSize: "1.45rem",
          fontWeight: 800,
          lineHeight: 1,
          my: 0.15,
        }}
      >
        {parts.day}
      </Typography>

      <Typography
        sx={{
          fontSize: "0.62rem",
          fontWeight: 700,
          letterSpacing: 0.5,
          lineHeight: 1,
        }}
      >
        {parts.month}
      </Typography>

      {parts.time && (
        <>
          <Divider
            sx={{
              width: "72%",
              borderColor: "rgba(255,255,255,0.55)",
              my: 0.5,
            }}
          />
          <Typography
            sx={{
              fontSize: "0.72rem",
              fontWeight: 700,
              lineHeight: 1,
              letterSpacing: 0.3,
            }}
          >
            {parts.time}
          </Typography>
        </>
      )}
    </Box>
  );
}
